import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DemoPage } from "./pages/DemoPage";

import "./styles/index.scss";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<DemoPage />} />

      <Route path="/demoCompany" element={<DemoPage />} />
      <Route path="/demoPage" element={<DemoPage />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
